import React, { useRef ,CSSProperties } from 'react';
import { DatePicker, DatePickerProps } from 'antd';

import styles from './DatePicker.module.scss'

interface DateProps extends Omit<DatePickerProps , 'style'>{
}

const CustomDatePicker = ({ onChange, ...rest}) => {
  return (
    <div className={styles.container}>
      <DatePicker 
        format='DD/MM/YYYY' 
        onChange={(value, string) => {
          const format = 'YYYY-MM-DD HH:mm'
          const st = value.format(format)
          return onChange(value, st)
        }}
        {...rest}
        />
    </div>
  )
}

export default CustomDatePicker;
